<template>
    <div class="filter-card">
        <!-- <div class="mobile-close">
            <CloseModalButton @click="$emit('closeFilters')" />
        </div> -->
        <div class="filter-header">
            <div>
                <img src="/media/images/filter_icon.svg" class="filter-icon">
                <span>{{ $trans('web_search.filters.filter') }}</span>
                <Indicator :show="activeFiltersCount() > 0" :value="activeFiltersCount()"
                    :backgroundColor="'#EA975A'" />
            </div>
            <div class="reset-button" @click="resetFilters()">
                {{ $trans('web_search.filters.reset_all') }}
            </div>
        </div>

        <div class="collapse">
            <template v-for="(filter, index) in filters" :key="index">
                <Collapse v-if="filter.hidden == false"
                    :class="{ 'active-border': (activeFiltersCount(filter.filter || index) > 0) }"
                    :is-active="index == 'competencies'">
                    <template v-slot:title>
                        <span>{{ filter.title }}</span>
                        <Indicator :show="activeFiltersCount(filter.filter || index) > 0"
                            :value="activeFiltersCount(filter.filter || index)" :backgroundColor="'#EA975A'" />
                    </template>

                    <FilterOptions v-if="Object.hasOwn(filter, 'options')" :filter-key="filter.filter || index"
                        :searchbar="filter.searchbar" :modifier-switch="filter.modifierSwitch"
                        :modifier-state="filter.modifierState" :options="filter.options"
                        :max-length="filter.maxLength || 6" />
                    <div v-else class="collapse-sub">
                        <template v-for="(subFilter, subIndex) in filter.filters" :key="subIndex">
                            <template v-if="subFilter.hidden == false">
                                <FilterOptions v-if="Object.hasOwn(subFilter, 'options')"
                                    :filter-key="subFilter.filter || subIndex" :title="subFilter.title"
                                    :searchbar="subFilter.searchbar" :modifier-switch="subFilter.modifierSwitch"
                                    :modifier-state="subFilter.modifierState"
                                    :select-all-switch="subFilter.selectAllSwitch" :options="subFilter.options"
                                    :max-length="subFilter.maxLength || 3" />
                            </template>
                        </template>
                    </div>
                </Collapse>
            </template>
        </div>
    </div>
</template>

<script>
import Collapse from './Utils/Collapse';
import FilterOptions from './FilterOptions';
import Indicator from './Indicator';
import CloseModalButton from './../Components/CheckoutProcess/CloseModalButton';

import { mapStores } from 'pinia'
import { useSelectedFiltersStore } from '@/stores/SelectedFiltersStore'

export default {
    components: {
        Collapse,
        FilterOptions,
        Indicator,
        CloseModalButton,
    },
    emits: ['closeFilters'],
    props: {
        filters: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapStores(useSelectedFiltersStore), // useSelectedFiltersStore => this.SelectedFiltersStore
    },
    methods: {
        resetFilters() {
            this.SelectedFiltersStore.resetFilters();
        },
        activeFiltersCount(key = null) {
            return this.SelectedFiltersStore.getActiveFiltersCount(key);
        }
    }
}
</script>

<style scoped>
.filter-card {
    color: #000;
    width: 400px;
    border-radius: 8px;
    padding: 20px;
    box-sizing: border-box;
    background: #CDDEE2;
    display: flex;
    flex-direction: column;
    gap: 15px;
    border: 1px solid #BCBAB6;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
}

.filter-header {
    padding-bottom: 5px;
    margin-bottom: 5px;
    font-size: 24px;
    font-weight: 500;
    color: #3C3C3C;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.filter-icon {
    position: relative;
    width: 24px;
    top: 3px;
    padding-right: 10px;
}

.reset-button {
    cursor: pointer;
    text-align: right;
    margin-right: 15px;
    margin-top: auto;
    font-style: italic;
    text-decoration: underline;
    font: italic normal 400 18px/22px Barlow;
    letter-spacing: -0.27px;
    color: #343433;
    opacity: 1;
}

.reset-button:hover {
    color: #2E7282;
}

.collapse {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.el-collapse {
    --el-collapse-border-color: transparent;
    --el-collapse-header-height: 34px;
    --el-collapse-header-bg-color: transparent;
    --el-collapse-header-text-color: #3C3C3C;
    --el-collapse-header-font-size: 20px;
    --el-collapse-content-bg-color: transparent;
    --el-collapse-content-font-size: 13px;
    --el-collapse-content-text-color: var(--el-text-color-primary);
    border-top: 1px solid var(--el-collapse-border-color);
    border-bottom: 1px solid var(--el-collapse-border-color);
}

.el-collapse :deep(.el-collapse) {
    --el-collapse-border-color: transparent;
    --el-collapse-header-height: 24px;
    --el-collapse-header-bg-color: transparent;
    --el-collapse-header-text-color: #3C3C3C;
    --el-collapse-header-font-size: 14px;
    --el-collapse-content-bg-color: transparent;
    --el-collapse-content-font-size: 13px;
    --el-collapse-content-text-color: var(--el-text-color-primary);
    border-top: 1px solid var(--el-collapse-border-color);
    border-bottom: 1px solid var(--el-collapse-border-color);
}

.el-collapse-item {
    background-color: #FAFAFA;
    text-align: left;
    font: normal normal 500 20px/24px Barlow;
    letter-spacing: 0px;
    color: #3C3C3C;
    opacity: 1;
}

.el-collapse :deep(.el-collapse .el-collapse-item__header) {
    flex-direction: row-reverse;
    justify-content: flex-end;
    font-weight: bold;
}

.el-collapse :deep(.el-collapse .el-collapse-item__arrow) {
    margin: 0;
}

.el-collapse :deep(.el-collapse-item__content) {
    padding-bottom: 5px;
}

.el-collapse :deep(.el-collapse-item__arrow.is-active) {
    color: #41ABC4;
}

.mobile-close {
    display: none;
}

@media only screen and (max-width: 790px) {
    .mobile-close {
        display: block;
        padding-bottom: 50px;
    }
}
</style>
